import React, { useState } from 'react';

import { Icon } from '~/eds/src/components/Icon/Icon';
import { Tabs } from '~/eds/src/components/Tabs/Tabs';
import { useIntl } from 'react-intl';
import FlexLayout from '~/ui/components/FlexLayout/FlexLayout';
import Text from '~/ui/components/Text/Text';

import BlankFormLink from '../BlankFormLink/BlankFormLink';

function IntakeFormLink({ intakeFormLinkId }) {
  const intl = useIntl();
  const [selectedTab, setSelectedTab] = useState('BLANK_FORM_LINK');

  const tabsConfig = {
    BLANK_FORM_LINK: {
      label: intl.formatMessage({
        id: 'IntakeFormLink.blankFormLink',
        defaultMessage: 'Blank Form Link',
        description: 'Tab label for blank form link',
      }),
      value: 'BLANK_FORM_LINK',
      panel: <BlankFormLink intakeFormLinkId={intakeFormLinkId} />,
    },
  };

  return (
    <FlexLayout flexDirection="column" space={4}>
      <FlexLayout alignItems="center" space={2} mb={0}>
        <Icon icon="link" color="status.new" />
        <Text color="gray-900" variant="l-dense-bold">
          {intl.formatMessage({
            id: 'IntakeFormLink.title',
            defaultMessage: 'Intake Form Link',
            description: 'Title for intake form link section',
          })}
        </Text>
      </FlexLayout>
      <Tabs
        selectedTab={selectedTab}
        tabs={Object.values(tabsConfig)}
        onSelectTab={(tab) => setSelectedTab(tab)}
      />
    </FlexLayout>
  );
}

export default IntakeFormLink;
